import { render } from "./BathGroupCreate.vue?vue&type=template&id=0aff0452&scoped=true"
import script from "./BathGroupCreate.vue?vue&type=script&lang=js"
export * from "./BathGroupCreate.vue?vue&type=script&lang=js"

import "./BathGroupCreate.vue?vue&type=style&index=0&id=0aff0452&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aff0452"]])

export default __exports__